export const BANNER_TITLE = "Opportunities need your attention";
export const BANNER_SUBTITLE = "You're missing out on revenue";
export const BANNER_REVENUE_LABEL = "Boost revenue up to";
export const BANNER_UNLOCK_LABEL = "Unlock demand";
export const BANNER_UNLOCK_VALUE = "New Buyer Invitations";
export const BANNER_CTA_LABEL = "Review all";
export const BANNER_REVIEW_ALL_HEAP_ID = "homepage-banner-review-all";
